<template>
  <div class="history">
    <v-base-card>
      <template v-slot:heading>
        学校一覧
      </template>

      <template v-slot:content>
        <v-row class="mb-0 pb-0">
          <v-col :cols="schoolCodeCols">
            <v-text-field
              v-model="schoolCode"
              label="学校コード"
              color="secondary"
              class="schoolcode-width"
            />
          </v-col>
          <v-col cols="2">
            <v-select
              v-model="selectedPrefectureCode"
              :items="prefectures"
              item-text="name"
              item-value="code"
              label="都道府県"
              clearable
              class="prefectres-width"
            ></v-select>
          </v-col>
          <v-col cols="1" class="d-flex align-center">
            <v-btn small color="secondary" @click="search">検索</v-btn>
          </v-col>
          <v-col :offset="offsetCols - 1" cols="3" class="d-flex" v-resize="setOffsetCols">
            <v-btn class="mt-5 ml-auto" small color="#4a81aa" dark @click.stop="downloadCsv">csvダウンロード</v-btn>
            <v-btn class="mt-5 ml-3" small color="#4a81aa" dark @click.stop="create">新規作成</v-btn>
          </v-col>
        </v-row>
        <v-data-table
          :headers="headers"
          :items="schools"
          :loading="loading"
          loading-text="Loading... Please wait"
          hide-default-footer
          :items-per-page="-1"
          :height="300"
        >
          <template #[`item.accounts`]="{ item }">
            <v-btn small color="secondary" rounded dark @click.stop="showAccounts(item)">確認</v-btn>
          </template>
          <template #[`item.applications`]="{ item }">
            <v-btn small color="secondary" rounded dark @click.stop="showApplications(item)">確認</v-btn>
          </template>
          <template #[`item.edit`]="{ item }">
            <v-btn icon @click.stop="edit(item)">
              <v-icon small dark>
                mdi-cog-outline
              </v-icon>
            </v-btn>
          </template>
          <template #[`item.delete`]="{ item }">
            <v-btn icon @click.stop="openDeleteConfirmDialog(item)">
              <v-icon dark>
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <v-pagination v-model="currentPage" :length="totalPages" :total-visible="7" color="secondary" @input="onPageChange" />
      </template>
    </v-base-card>
    <v-btn class="mt-5 ml-auto" small color="#4a81aa" dark @click.stop="vdropzoneInitialize">csvアップロード</v-btn>
    <v-alert class="mt-5 ml-auto csv_upload" v-if="vdropzoneErrors.length" type="error">
      <div v-for="(error,index) in vdropzoneErrors" :key="index">
        {{ error }}
      </div>
    </v-alert>
    <v-alert class="mt-5 ml-auto csv_upload" v-if="vdropzoneSuccessStr" type="success">
      {{ vdropzoneSuccessStr }}
    </v-alert>
    <vue-dropzone
      ref="myVueDropzone2"
      id="dropzone2"
      v-if="showUploadArea"
      :options="dropzoneOptions"
      @vdropzone-success="vdropzoneSuccess"
      @vdropzone-sending="vdropzoneSending"
      @vdropzone-complete="vdropzoneComplete"
    />

    <v-confirm-dialog
      ref="confirm"
      title="学校削除"
      :message="deleteMessage"
      buttonMessage="削除"
      @confirm="confirmDeletion"
    />
  </div>
</template>

<script>
import vueDropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import VBaseCard from '@/components/molecules/BaseCard'
import VConfirmDialog from '@/components/atoms/ConfirmDialog'
import { saveAs } from 'file-saver'

export default {
  components: {
    VBaseCard,
    vueDropzone,
    VConfirmDialog,
  },
  data () {
    return {
      headers: [
        { text: '学校名', align: 'start', value: 'name' },
        { text: '学校コード', align: 'start', value: 'code' },
        { text: '都道府県', align: 'center', value: 'prefecture_name'},
        { text: 'アカウント一覧', align: 'center', value: 'accounts', sortable: false },
        { text: '申し込み一覧', align: 'center', value: 'applications', sortable: false },
        { text: '編集', align: 'center', value: 'edit', sortable: false },
        { text: '削除', align: 'center', value: 'delete', sortable: false },
      ],
      schools: [],
      selectedPrefectureCode: null,
      showUploadArea: false,
      dropzoneOptions: {
          url: `${this.$axios.defaults.baseURL}/api/v1/admin/schools/csv_upload`,
          method: 'post',
          acceptedFiles: '.csv',
          headers: {
            'My-Awesome-Header': 'header value',
            'access-token': this.$axios.defaults.headers.common['access-token'],
            'client': this.$axios.defaults.headers.common['client'],
            'uid': this.$axios.defaults.headers.common['uid'],
          },
          thumbnailWidth: 150,
          maxFilesize: 0.5,
          dictDefaultMessage:"<i class='mdi mdi-cloud-upload'></i>ファイルをアップする"
      },
      vdropzoneErrors: [],
      vdropzoneSuccessStr: null,
      deletedSchool: {
        id: null,
        name: '',
      },
      loading: false,
      currentPage: 1,
      totalPages: 0,
      schoolCode: null,
      schoolCodeCols: 2,
      offsetCols: 5
    }
  },

  async mounted() {
    await this.getSchools()
  },

  computed: {
    deleteMessage() {
      return `${this.deletedSchool.name} を削除します。よろしいですか。`
    },
    prefectures() {
      return this.$store.state.master.allPrefectures
    },
  },

  methods: {
    async getSchools() {
      this.loading = true
      const params = new URLSearchParams()
      params.append('page', this.currentPage)
      if (this.schoolCode) params.append('q[code_cont]', this.schoolCode)
      if (this.selectedPrefectureCode) params.append('q[prefecture_code_eq]', this.selectedPrefectureCode)
      const res = await this.$axios(`/api/v1/admin/schools?${params}`)
      this.schools = res.data.items
      this.totalPages = res.data.total_pages
      this.loading = false
    },
    search() {
      this.currentPage = 1
      this.getSchools()
    },
    onPageChange() {
      this.getSchools()
    },
    openDeleteConfirmDialog(school) {
      this.deletedSchool = school
      this.$refs.confirm.open()
    },
    // 先生_お知らせ削除API
    async confirmDeletion() {
      const url = `api/v1/admin/schools/${this.deletedSchool.id}`
      await this.$axios.delete(url)
      this.$toasted.global.success({ message: `${this.deletedSchool.name}を削除しました` })
      this.getSchools()
    },
    // 先生_お知らせCSVダウンロードAPI
    async downloadCsv() {
      const prefecture_code = this.selectedPrefectureCode
        ? this.prefectures.find(pref => pref.code === this.selectedPrefectureCode).code
        : ''
      const res = await this.$axios(`/api/v1/admin/schools.csv/?q[prefecture_code_eq]=${prefecture_code}`, {responseType: 'blob'})
      const blob = new Blob([res.data], { type: res.data.type })

      //レスポンスヘッダからファイル名を取得
      const contentDisposition = res.headers['content-disposition']
      const fileName = this.getFileName(contentDisposition)

      saveAs(blob, fileName)
    },
    getFileName(contentDisposition){
      let fileName = contentDisposition.substring(contentDisposition.indexOf("''") + 2,
                                                    contentDisposition.length
                                                 )
      //デコードするとスペースが"+"になるのでスペースへ置換
      fileName = decodeURI(fileName).replace(/\+/g, ' ')

      return fileName
    },
    vdropzoneSending (file, xhr) {
      this.$app.$refs.loading.open({message: '処理中です。少々お待ちください。'})
      xhr.responseType = 'blob'
      xhr.dataType = 'binary'
    },
    async vdropzoneSuccess (file) {
      const res = file.xhr.response
      const contentType = res.type
      if (contentType === 'application/json') {
        // エラー
        this.vdropzoneErrors = JSON.parse(await res.text()).messages
        this.vdropzoneSuccessStr = null
      }else{
        const blob = new Blob([res], { type: contentType})
        //レスポンスヘッダからファイル名を取得
        const contentDisposition = file.xhr.getResponseHeader('Content-Disposition')
        const fileName = this.getFileName(contentDisposition)
        saveAs(blob, fileName)

        this.vdropzoneErrors = []
        await this.getSchools()
        this.vdropzoneSuccessStr = 'CSVアップロードが完了しました'
      }
    },
    vdropzoneComplete(){
      this.$app.$refs.loading.close()
    },
    vdropzoneInitialize() {
      this.showUploadArea = !this.showUploadArea
      this.vdropzoneErrors = []
      this.vdropzoneSuccessStr = null
    },
    edit(school) {
      this.$store.commit('school/setSchool', school)
      this.$router.push('/admin/school')
    },
    create() {
      this.$store.commit('school/initialize')
      this.$router.push('/admin/school')
    },
    showAccounts(school) {
      this.$store.commit('school/setSchool', school)
      this.$router.push('/admin/accounts')
    },
    showApplications(school) {
      this.$store.commit('school/setSchool', school)
      this.$router.push(`/admin/applications/${school.id}`)
    },
    setOffsetCols() {
      //「CSVダウンロード」「新規作成」ボタンがはみ出ないように、画面幅に応じてcolsを調整
      if(1080 <= window.innerWidth) this.offsetCols = 5
      else if(896 <= window.innerWidth && window.innerWidth <= 1079) this.offsetCols = 4
      else this.offsetCols = 2

      //学校コードのcolsも調整（ipad縦向きの場合、cols=2のままだと表示エリアが都道府県選択と被ってしまうため）
      if(this.offsetCols===2) this.schoolCodeCols = 3
      else this.schoolCodeCols = 2
    }
  }
}
</script>

<style lang="stylus" scoped>

.select
  font-size 11px !important
.csv_upload
  font-size 14px

.schoolcode-width
  min-width 100px //学校コード入力エリアの最小幅固定
.prefectres-width
  min-width 128px //都道府県選択エリアの最小幅固定
</style>
